<template>
    <div class="notfound">
        <van-empty description="404 很抱歉，您访问的资源不存在" />
    </div>
</template>
<style lang="less" scoped>
.notfound{
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>